import { useEffect } from 'react';
import { Button, Form, type FormProps, Input, message, Modal } from 'antd';
import { editInquiry } from '@/services/api/chatService';
import { useTranslation } from 'react-i18next';

type FieldType = {
  name?: string;
};

const ModalEditInquiry: any = ({
  inquiry,
  open,
  updateInquiry,
  onOk,
  onCancel,
}: any) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (open && inquiry) {
      form.setFieldValue('name', inquiry?.name);
    }
  }, [inquiry, open, form]);

  const onFinish: FormProps<FieldType>['onFinish'] = async values => {
    const payload: any = { name: values.name };
    if (inquiry?.project_id) payload['project_id'] = inquiry?.project_id;
    const response = await editInquiry(inquiry.id, payload);
    if (!response.success) {
      return;
    }
    updateInquiry(response.data);
    onCancel();
  };

  return (
    <div>
      <Modal
        title={t('home.chat.modals.edit.title')}
        open={open}
        destroyOnClose
        footer={
          <Button type="primary" onClick={() => form.submit()}>
            {t('home.chat.modals.edit.confirm')}
          </Button>
        }
        onOk={onOk}
        onCancel={onCancel}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item name="name" label={t('home.chat.modals.edit.label')}>
            <Input placeholder={t('home.chat.modals.edit.placeholder')} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalEditInquiry;
